import { takeLatest, takeEvery, call, put } from 'redux-saga/effects';

import {
  FETCH_EMPLOYEES, fetchEmployeesSuccess, fetchEmployeesFailed, fetchingEmployees,
  FETCH_EMPLOYEE, fetchEmployeeSuccess, fetchingEmployee,
} from '../actions/employees';
import { fetchCol, fetchDoc } from './helper';
import { post } from '../utils/rest';
import { showDialog, showError } from '../actions/dialogs';

import { saveEmployeeRoutine, removeEmployeeRoutine } from '../routines';

import { firestore, getTenantPath, getTenantId } from '../utils/firebase';
import { toArray } from '../utils/helper';

function enrich(employee) {
  return employee;
}

function fetchEmployees() {
  return fetchCol(getTenantPath('/employees'), enrich);
}

function fetchEmployee(id) {
  return fetchDoc(getTenantPath(`employees/${id}`), enrich);
}

function* fetchEmployeesSaga() {
  try {
    yield put(fetchingEmployees());
    const employees = yield call(fetchEmployees);
    yield put(fetchEmployeesSuccess(toArray(employees).filter((employee) => !employee.deleted)));
  } catch (e) {
    yield put(fetchEmployeesFailed(e));
  }
}

function* watchFetchEmployeesSaga() {
  yield takeLatest(FETCH_EMPLOYEES, fetchEmployeesSaga);
}

function* fetchEmployeeSaga(action) {
  try {
    yield put(fetchingEmployee(action.employeeId));
    const employee = yield call(fetchEmployee, action.employeeId);
    employee.id = action.employeeId;
    yield put(fetchEmployeeSuccess(employee));
  } catch (e) {
    yield put(fetchEmployeesFailed(action.employeeId, e));
  }
}

function* watchFetchEmployeeSaga() {
  yield takeLatest(FETCH_EMPLOYEE, fetchEmployeeSaga);
}

function* watchSaveEmployeeSaga() {
  yield takeLatest(saveEmployeeRoutine.TRIGGER, saveEmployeeSaga);
}

function saveEmployee(employee) {
  console.log('saveEmployee', employee);
  if (employee.id) {
    // update employee
    return firestore.doc(getTenantPath(`employees/${employee.id}`))
      .update(employee)
      .then(() => employee); // TODO
  } else {
    // create employee
    const path = `/v1/tenants/${getTenantId()}/employees`;
    return post(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(employee),
    }).catch((err) => {
      throw new Error(err.message);
    });
  }
}

function* saveEmployeeSaga(action) {
  const employee = action.payload.toJS();
  try {
    // trigger request action
    yield put(saveEmployeeRoutine.request(employee));
    // perform request to '/some_url' to fetch some data
    const response = yield call(saveEmployee, employee);
    // if request successfully finished
    console.log('response', response);
    response.name = `${response.firstName} ${response.lastName}`;
    yield put(saveEmployeeRoutine.success({ success: true, employee: response }));
  } catch (error) {
    // if request failed
    console.error(error);
    yield put(showError('Unable to save employee', error.message));
    yield put(saveEmployeeRoutine.failure({ success: false, message: error.message }));
  } finally {
    // trigger fulfill action
    yield put(saveEmployeeRoutine.fulfill());
  }
}

function* watchRemoveEmployeeSaga() {
  // run fetchDataFromServer on every trigger action
  yield takeEvery(removeEmployeeRoutine.TRIGGER, removeEmployeeSaga);
}

function removeEmployee(employee) {
  return firestore.doc(getTenantPath(`employees/${employee.id}`))
    .update({ deleted: { at: new Date().toISOString() } })
    .then(() => employee);
}

function* removeEmployeeSaga(action) {
  const employee = action.payload;
  try {
    // trigger request action
    yield put(removeEmployeeRoutine.request(employee));
    // perform request to '/some_url' to fetch some data
    yield call(removeEmployee, employee);
    // if request successfully finished
    yield put(removeEmployeeRoutine.success({ success: true, employee }));
  } catch (err) {
    console.error(err);
    // if request failed
    yield put(removeEmployeeRoutine.failure({ success: false }));
    yield put(showDialog('alert', { title: 'Unable to remove employee', message: err.message, type: 'severe' }));
  } finally {
    // trigger fulfill action
    yield put(removeEmployeeRoutine.fulfill());
  }
}

export {
  fetchEmployeesSaga,
  watchFetchEmployeesSaga,
  fetchEmployeeSaga,
  watchFetchEmployeeSaga,
  watchSaveEmployeeSaga,
  watchRemoveEmployeeSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/employees.js